export default __webpack_public_path__ + "static/media/SWT1210.34I-35670_-20771_0.cbafa460.jpg";